export const Groups = {
  path: '/groups',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'groups',
      component: () => import('pages/groups/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'グループ一覧',
        path: '/groups',
        condition: 'group',
      },
    },
    {
      path: 'create',
      name: 'groups-create',
      component: () => import('pages/groups/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: '新規作成',
        parents: [
          {
            title: 'グループ一覧',
            path: '/groups',
            condition: 'group',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'groups-id',
      component: () => import('src/pages/groups/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'グループ一覧',
            path: '/groups',
            condition: 'group',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'groups-id-edit',
      component: () => import('src/pages/groups/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: '編集',
        parents: [
          {
            title: 'グループ一覧',
            path: '/groups',
            condition: 'group',
          },
          {
            title: ':name',
            path: '/groups/:id',
          },
        ],
      },
    },
  ],
};
